import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NbDialogService } from "@nebular/theme";
import { Lead } from "../../../@core/data/lead";
import { LeadService } from "../../../@core/api/lead.service";

@Component({
  selector: "ngx-projects-leads-row",
  templateUrl: "./projects-leads-row.component.html",
  styleUrls: ["./projects-leads-row.component.scss"],
})
export class ProjectsLeadsRowComponent implements OnInit {
  @Input() lead: Lead;
  @Output() updateList = new EventEmitter();

  // Aggiungi una variabile per gestire il toggle della visibilità della risposta
  public isResponseVisible: boolean = false;

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private leadService: LeadService
  ) {}

  async ngOnInit() {}

  // Metodo per attivare/disattivare la visibilità della risposta
  toggleResponseVisibility(): void {
    this.isResponseVisible = !this.isResponseVisible;
  }

  async sendLead() {
    this.lead.needToSend = true;
    await this.leadService.sendLead(this.lead.id)
    this.lead = await this.leadService.getLead(this.lead.id)
  }
}
